class Navigation {
  constructor() {

  }

  init() {

    const hamburger = document.querySelector('.menu-toggle');
    const navigation = document.querySelector('.nav');

    hamburger.addEventListener('click',()=>{

       hamburger.classList.toggle('is-active')
       navigation.classList.toggle('mobile-nav')
    })

  }
}

export default new Navigation();
